// app/javascript/controllers/modal_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["modal", "settingsModal", "testModal"]

    connect() {
        // Close on escape key
        this.handleEscape = this.handleEscape.bind(this)
        document.addEventListener('keydown', this.handleEscape)
    }

    disconnect() {
        document.removeEventListener('keydown', this.handleEscape)
    }

    open(event) {
        const modalName = event.currentTarget.dataset.modalName

        // Support generic modal target (no modalName needed)
        if (!modalName && this.hasModalTarget) {
            this.modalTarget.classList.remove('hidden')
            document.body.classList.add('overflow-hidden')
            const firstInput = this.modalTarget.querySelector('input, select, textarea')
            if (firstInput) {
                setTimeout(() => firstInput.focus(), 100)
            }
            return
        }

        // Support named modals for backwards compatibility
        if (modalName === 'settings' && this.hasSettingsModalTarget) {
            this.settingsModalTarget.classList.remove('hidden')
            document.body.classList.add('overflow-hidden')
            const firstInput = this.settingsModalTarget.querySelector('input, select, textarea')
            if (firstInput) {
                setTimeout(() => firstInput.focus(), 100)
            }
        } else if (modalName === 'test' && this.hasTestModalTarget) {
            this.testModalTarget.classList.remove('hidden')
            document.body.classList.add('overflow-hidden')
            const firstInput = this.testModalTarget.querySelector('input, select, textarea')
            if (firstInput) {
                setTimeout(() => firstInput.focus(), 100)
            }
        }
    }

    close() {
        // Close all modals in this controller
        if (this.hasModalTarget) {
            this.modalTarget.classList.add('hidden')
        }
        if (this.hasSettingsModalTarget) {
            this.settingsModalTarget.classList.add('hidden')
        }
        if (this.hasTestModalTarget) {
            this.testModalTarget.classList.add('hidden')
        }
        document.body.classList.remove('overflow-hidden')
    }

    handleEscape(event) {
        if (event.key === 'Escape') {
            this.close()
        }
    }
}
